import { HLS_KR, HLS, SS } from '../../utils/playerConstants';
import deviceInfo from '../all/deviceInfo';

const multipleaudio = {};
// HLS_KR
multipleaudio.hls_kr = {};
multipleaudio.hls_kr.vod = false;
multipleaudio.hls_kr.live = false;
multipleaudio.hls_kr.timeshift = false;
// HLS
multipleaudio.hls = {};
multipleaudio.hls.vod = false;
multipleaudio.hls.live = false;
multipleaudio.hls.timeshift = false;
// SS
multipleaudio.smooth_streaming = {};
multipleaudio.smooth_streaming.vod = true;
multipleaudio.smooth_streaming.live = false;
multipleaudio.smooth_streaming.timeshift = false;

// Put only SINGLE streams here
const supported_stream_types = {};
// in priority order, first has a major priority
supported_stream_types.vod = [SS, HLS];
supported_stream_types.live = [HLS_KR, HLS];
supported_stream_types.timeshift = [HLS_KR, HLS];

export default {
  appKey: 'a9028c58f218a7afd2d32ad11d0058e0', // TODO ESTO ES DE NAGRA
  appSubkey: 'workstation',
  // Request params
  device_category: 'tv',
  /* device_id:"nousar", */
  device_manufacturer: 'sony',
  device_model: 'sony',
  device_name: 'sony',
  device_so: deviceInfo.os.description || 'default', // como obtener device_so
  device_type: 'tv',
  stream_type: 'smooth_streaming',
  // multipleaudio: multipleaudio, //Estos valores ahora se toman de la llave supported_stream de METADATA
  // supported_stream_types: supported_stream_types, //Estos valores ahora se toman de la llave supported_stream de METADATA
  useEpgPostals: true,
  akamai_id: 'WksSTV',
  // akamai_mfwk: 'mfwktv2sony-api.clarovideo.net',
  akamai_mfwk: (window.location && window.location.protocol) ? window.location.protocol + '//' + 'mfwktv2sony-api.clarovideo.net' : 'http://mfwktv2sony-api.clarovideo.net'
};



// WEBPACK FOOTER //
// ./src/devices/workstation/config.js